// extracted by mini-css-extract-plugin
module.exports = {"root":"HomepageTopInjectorDesktop_root__1NnCI"};